import { basicPlanConditionSection } from './basicplan-condition-section'

export const sections = {
  basicPlanCondition: basicPlanConditionSection,
}
